import { Button, DeleteIcon, EditIcon } from '@/ui/primitives';
import type { ReactElement } from 'react';

type DetailHeaderIconButtonProps = {
  label: string;
  disabled?: boolean;
  color?: 'default' | 'error';
  onClick: () => void;
};

const resolveDetailHeaderActionText = (label: string): string => {
  if (label.startsWith('Edit ')) return 'Edit';
  if (label.startsWith('Delete ')) return 'Delete';
  return label;
};

const resolveDetailHeaderActionIcon = (label: string, color: 'default' | 'error'): ReactElement => {
  if (color === 'error' || label.startsWith('Delete ')) {
    return <DeleteIcon />;
  }
  return <EditIcon />;
};

export const DetailHeaderIconButton = ({
  label,
  disabled = false,
  color = 'default',
  onClick,
}: DetailHeaderIconButtonProps): ReactElement => (
  <Button
    aria-label={label}
    disabled={disabled}
    fullWidthOnMobile={false}
    variant={color === 'error' ? 'destructive' : 'secondary'}
    startIcon={resolveDetailHeaderActionIcon(label, color)}
    onClick={onClick}
  >
    {resolveDetailHeaderActionText(label)}
  </Button>
);
